import request from '../utils/request'

/**
 * 获取当前管理员所属企业信息
 */
export function getCurrentCompany() {
  return request({
    url: '/manager/company',
    method: 'get'
  })
}

/**
 * 更新当前管理员所属企业信息
 */
export function updateCurrentCompany(data) {
  return request({
    url: '/manager/company',
    method: 'put',
    data
  })
}

